import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { connect } from 'react-redux'

// this is used to create scrollbars on windows devices like the ones from apple devices
import * as Ps from 'perfect-scrollbar';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.min.css';
// react component that creates notifications (like some alerts with messages)
import NotificationSystem from 'react-notification-system';

import Sidebar from '../../components/Sidebar/Sidebar.jsx';
import Header from '../../components/Header/Header.jsx';
import Footer from '../../components/Footer/Footer.jsx';

// dinamically create dashboard routes
import dashRoutes from '../../routes/dash.jsx';

// style for notifications
import {style} from "../../variables/Variables.jsx";

import AuthService from '../../services/AuthService.js';


const Auth = new AuthService();

class Dash extends Component {
  constructor(props) {
    super(props);
    this.handlePushNotifications = this.handlePushNotifications.bind(this);
    this.state = {
      _notificationSystem: null,
    };
  }
  componentDidMount() {
    if (Auth.loggedIn()) {
      this.setState({_notificationSystem: this.refs.notificationSystem});
      if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
        Ps.initialize(this.refs.mainPanel, {
          wheelSpeed: 2,
          suppressScrollX: true
        });
      }
    }
  }

  // function that shows/hides notifications - it was put here, because the wrapper div has to be outside the main-panel class div
  // pushNotification('success', 'tc', 'pe-7s-check', (<div>Usuario creado satisfactoriamente!</div>), true);
  handlePushNotifications(level, position, icon, message, autoDismiss){
    this.state._notificationSystem.addNotification({title: (<span data-notify="icon" className={icon}></span>), message: message, level: level, position: position, autoDismiss: autoDismiss});
  }

  // function that creates perfect scroll bar for windows users (it creates a scrollbar that looks like the one from apple devices)
  isMac() {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }
  componentDidUpdate(e) {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      setTimeout(() => {
        Ps.update(this.refs.mainPanel)
      }, 350);
    }
    if (e.history.action === "PUSH") {
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  componentWillMount() {
    if (document.documentElement.className.indexOf('nav-open') !== -1) {
      document.documentElement.classList.toggle('nav-open');
    }
  }
  render() {
    if (!Auth.loggedIn())
      return( <Redirect to="/login"/>)

    return (<div className="wrapper">
      <NotificationSystem ref="notificationSystem" style={style}/>
      <Sidebar {...this.props}/>
      <div className={"main-panel" + (
          this.props.location.pathname === "/maps/full-screen-maps"
            ? " main-panel-maps"
            : "")} ref="mainPanel">
        <Header {...this.props}/>
        <BlockUi tag="main" blocking={this.props.loading} message="Cargando...">
          <Switch>
            {
              dashRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return prop.views.map((prop, key) => {
                    return (<Route path={prop.path} component={prop.component} key={key}/>);
                  })
                } else {
                  if (prop.redirect)
                  return (<Redirect from={prop.path} to={prop.pathTo} key={key}/>);
                  else
                  if (prop.exact) {
                    return (<Route path={prop.path} exact key={key} render={routeProps => <prop.component {...routeProps} pushNotification={this.handlePushNotifications} currentUser={prop.currentUser}/>}/>);
                    //return (<Route path={prop.path} exact component={prop.component} key={key} />);
                  }
                  return (<Route path={prop.path} key={key} render={routeProps => <prop.component {...routeProps} pushNotification={this.handlePushNotifications} currentUser={prop.currentUser}/>}/>);
                  //return (<Route path={prop.path} component={prop.component} key={key}/>);
                }
              })
            }
          </Switch>
        </BlockUi>
        <Footer fluid="fluid"/>
      </div>
    </div>);
  }
}

function mapStateToProps(state, ownProps) {
    return {
      loading: state.get('loading'),
    };
}

export default connect(mapStateToProps)(Dash);



// WEBPACK FOOTER //
// ./src/containers/Dash/Dash.jsx